import API from './apiCreate'
import { getParams } from './getParams'

export type HistoryCategory = 'schedule' | 'journal' | 'ktp' | 'students' | 'employees'
export type HistoryAction = 'create' | 'copy' | 'reschedule' | 'swap' | 'update' | 'delete'
export interface HistoryLesson {
  id: number
  subject: string
  lesson_type: string
  recurrence: string
  date: string
  start_time: string
  end_time: string
  teacher: string
  groups: string
  students: string
  student_names?: string[]
}
export interface ScheduleHistoryPresentation {
  action: HistoryAction
  action_label: string
  scope: string
  date_range?: { from: string; to: string }
  before: HistoryLesson[]
  after: HistoryLesson[]
  changes: { label: string; old: string; new: string }[]
}
export interface ChangeHistoryRow {
  id: number
  entity_id: number
  entity_type: string
  entity_label: string
  subject_id?: number
  actor_id?: number
  actor_name: string
  action: HistoryAction
  source: string
  created_at: number
  changes: Record<string, { old: unknown; new: unknown }>
  category?: HistoryCategory
  context?: {
    section?: string
    action_label?: string
    student?: string
    course?: string
    group?: string
    date?: string
    column?: string
    work?: string
    topic?: string
    is_additional?: boolean
    field_labels?: Record<string, string>
    value_labels?: Record<string, Record<string, string>>
  }
  presentation?: ScheduleHistoryPresentation
}

export const changeHistoryApi = {
  index: (params: Record<string, unknown>) =>
    API.get(`change-history/index${getParams(params)}`),
  user: (id: number) => API.get(`change-history/user?id=${id}`),
}
